import React, {useEffect, useMemo, useState} from 'react';
import PropTypes from 'prop-types';
import {useTranslation} from 'react-i18next';
import {connect} from 'react-redux';
import {Select} from 'antd';
import {
  StyledTableFilters,
  StyledTableFiltersSearch,
  StyledTableFiltersElements,
  StyledTableFiltersElementsSpace,
  StyledTableFiltersRightSideContent
} from './StyledTableFilters';
import {formHelpers, VendorPriorityOptions, VendorStatusesOptions} from '../../../../utils/helpers';

const multipleSelectProps = {
  styles: {popup: { root: {minWidth: 210} } },
  maxTagCount: 2,
  mode: 'multiple',
  size: 'large',
  showSearch: true
}

const TableFilters = ({
  dispatch,
  defaultQuery = {},
  onFilter,
  rightSideContent,

  vendorsTags,
  ...rest
}) => {
  const [t] = useTranslation('main');
  const [values, setValues] = useState({
    category: [],
    status: [],
    priority: undefined,
    search: undefined
  });
  const [priorityOptions, ] = useState([
    {label: t('allPriorities'), value: ''},
    ...VendorPriorityOptions(),
  ]);
  const [statusOptions, ] = useState([
    {label: t('allStatuses'), value: ''},
    ...VendorStatusesOptions(),
  ]);

  const tagOptions = useMemo(() => formHelpers.getTagOptions(vendorsTags), [vendorsTags]);

  useEffect(() => {
    setValues({...values, ...defaultQuery});
  }, [defaultQuery]); // eslint-disable-line react-hooks/exhaustive-deps

  const handleOnFilter = (key, value) => {
    setValues({...values, [key]: value});
    onFilter && onFilter({[key]: value});
  }

  return (
    <StyledTableFilters {...rest}>
      <StyledTableFiltersElements>
        <StyledTableFiltersElementsSpace
          enabledRightSideContent={rightSideContent !== undefined}
          size='small'
        >
          <StyledTableFiltersSearch
            allowClear
            onSearch={(value) => handleOnFilter('search', value)}
            placeholder={t('search')}
            value={values.search}
            size='large'
          />
          <Select
            onChange={(value) => handleOnFilter('status', value)}
            options={formHelpers.getStatusOptions(statusOptions)}
            placeholder={t('allStatuses')}
            size='large'
            value={values.status}
          />
          <Select
            onChange={(value) => handleOnFilter('priority', value)}
            options={priorityOptions}
            placeholder={t('allPriorities')}
            size='large'
            value={values.priority}
          />
          <Select
            {...multipleSelectProps}
            onChange={(value) => handleOnFilter('category', value)}
            options={tagOptions}
            placeholder={t('category')}
            value={values.category}
          />
          {rightSideContent && <StyledTableFiltersRightSideContent>{rightSideContent}</StyledTableFiltersRightSideContent>}
        </StyledTableFiltersElementsSpace>
      </StyledTableFiltersElements>
    </StyledTableFilters>
  );
}

TableFilters.propTypes = {
  defaultQuery: PropTypes.object,
  onFilter: PropTypes.func,
  rightSideContent: PropTypes.any
}

const mapStateToProps = ({ company: { vendorsTags } }) => ({
  vendorsTags,
});

export default connect(mapStateToProps, null)(TableFilters);
